type NoteLog = { i: string; p: string; t: number };

const MAX_LOG_LENGTH = 500;

// ts-prune-ignore-next
class NoteLogs {
  private key = "note-logs";
  private logs: NoteLog[] = [];

  constructor() {
    try {
      const raw = localStorage.getItem(this.key);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) this.logs = parsed as NoteLog[];
      }
    } catch {
      this.logs = [];
    }
  }

  get allLogs(): NoteLog[] {
    return this.logs;
  }

  push(id: string, pos: string, timestamp = Date.now()) {
    this.logs.unshift({ i: id, p: pos, t: timestamp });
    if (this.logs.length > MAX_LOG_LENGTH) this.logs.length = MAX_LOG_LENGTH;
    this.save();
  }

  private save() {
    try {
      localStorage.setItem(this.key, JSON.stringify(this.logs));
    } catch {
      console.error("Failed to save note logs");
    }
  }
}

const noteLogs = new NoteLogs();
export { noteLogs };
